/**
 * Workshop-step light primitives. The workshop deck section (heavy: pptx/PDF deck builders) lives in
 * the lazily-loaded `./workshopDeck`; this module holds only the jest-/bundle-safe `CommentsBlock`
 * wrapper so the registration hub can import it statically without pulling the deck builders.
 *
 * `CommentsBlock` reuses the existing `Comments` leaf verbatim, feeding it the step index and author
 * from the shared `RunnerContext`. No presentation is duplicated.
 *
 * `config.hideWhenPresenting` mirrors the original bodies: the deep-dive and recommendation steps hid
 * their Comments in the Go Live view (`{!presenting && <Comments/>}`), while the workshop step always
 * showed them. The layout entry opts in per step, so the same primitive serves all three.
 */
import { Comments } from '../../components/steps/Comments';
import type { PrimitiveProps } from './registry';

export function CommentsBlock({ ctx, config }: PrimitiveProps): JSX.Element | null {
  if (config?.hideWhenPresenting && ctx.presenting) return null;
  return <Comments stepIndex={ctx.stepIndex} author={ctx.author} />;
}
